import Layout from 'Layout/Layout';
export default Layout;